import { alreadyDisconnectedToChatNotification } from '../entities/notification/notifications';
export class ChatApplicationService {
    constructor(chatGateway, interfaceGateway) {
        this.chatGateway = chatGateway;
        this.interfaceGateway = interfaceGateway;
    }
    sendMessageToPlayer(messageForPlayer) {
        return this.chatGateway.sendMessageToPlayer(messageForPlayer);
    }
    sendMessage(message) {
        return this.chatGateway.sendMessage(message);
    }
    isConnected() {
        return this.chatGateway.isConnected();
    }
    connectChat(username, token, channel) {
        return this.chatGateway.connect(username, token, channel);
    }
    disconnectChat() {
        return this.isConnected()
            .then(isConnected => isConnected
            ? this.chatGateway.disconnect()
            : this.interfaceGateway.notify(alreadyDisconnectedToChatNotification))
            .catch(error => Promise.reject(error));
    }
}
